import Icon from '../Components/Icons/Icon';

function AboutPage() {
  const googleMapsEmbedUrl =
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3533.44659991048!2d85.31167337581027!3d27.672588527022988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19f10890a121%3A0xb7cb4eaa525325b2!2sLalitpur%20Eye%20Care%20Center!5e0!3m2!1sen!2snp!4v1774529460193!5m2!1sen!2snp';

  const services = [
    {
      icon: 'eye',
      title: 'Eye Checkups',
      description: 'Complete vision exams and consultations'
    },
    {
      icon: 'microscope',
      title: 'Modern Equipment',
      description: 'Latest technology for accurate diagnosis'
    },
    {
      icon: 'users',
      title: 'All Ages',
      description: 'Care for children, adults, and seniors'
    },
    {
      icon: 'package',
      title: 'Eye Care Products',
      description: 'Quality eyewear and contact lenses'
    },
    {
      icon: 'clock',
      title: 'Quick Service',
      description: 'Efficient appointments and follow-ups'
    },
    {
      icon: 'hospital',
      title: 'Professional Care',
      description: 'Experienced ophthalmologists and staff'
    }
  ];

  return (
    <section className="page-card about-page">
      <p className="profile-page__eyebrow">About Us</p>
      <h1 className="page-card__title">Your Trusted Eye Care Partner</h1>
      <p className="page-card__text">
        Providing comprehensive eye care services with modern technology and experienced professionals.
      </p>

      <div className="about-page__hero">
        <div className="about-page__mission">
          <div className="about-page__icon"><Icon name="target" size={30} /></div>
          <div>
            <h2>Our Mission</h2>
            <p>Quality eye care for healthier vision</p>
          </div>
        </div>
        <div className="about-page__vision">
          <div className="about-page__icon"><Icon name="eye" size={30} /></div>
          <div>
            <h2>Our Vision</h2>
            <p>Reliable care you can trust</p>
          </div>
        </div>
      </div>

      <div className="about-page__grid">
        {services.map((service, index) => (
          <article key={index} className="about-page__item">
            <div className="about-page__item-icon"><Icon name={service.icon} size={26} /></div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </article>
        ))}
      </div>

      <div className="about-location-workplace">
        <div className="about-location-card">
          <div className="about-location-card__header">
            <div className="about-location-card__icon"><Icon name="map-pin" size={24} /></div>
            <div>
              <h2 className="about-location-card__title">Our Location</h2>
              <p className="about-location-card__subtitle">Visit us in Lalitpur</p>
            </div>
          </div>

          <div className="about-location-card__map-shell">
            <iframe
              className="about-location-card__map"
              title="Our Location Map"
              loading="lazy"
              src={googleMapsEmbedUrl}
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

        <div className="about-location-card">
          <div className="about-location-card__header">
            <div className="about-location-card__icon"><Icon name="hospital" size={24} /></div>
            <div>
              <h2 className="about-location-card__title">Our Facility</h2>
              <p className="about-location-card__subtitle">Modern eye care center</p>
            </div>
          </div>

          <div className="about-workplace-images" aria-label="Workplace photos">
            <img
              className="about-workplace-image about-workplace-image--1"
              src="/2024-10-12.webp"
              alt="Workplace 1"
              loading="lazy"
            />
            <img
              className="about-workplace-image about-workplace-image--2"
              src="/IMG_20241013_125340(1).webp"
              alt="Workplace 2"
              loading="lazy"
            />
            <img
              className="about-workplace-image about-workplace-image--3"
              src="/2024-10-13.webp"
              alt="Workplace 3"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutPage;
